// extracted by mini-css-extract-plugin
export default {"main":"style_main__pXD80","text":"style_text__zUM24","information1":"style_information1__3JGJM","buttons":"style_buttons__CoMLf"};